import React from 'react';

function Contact() {
    return (
        <div className="p-4 bg-white shadow rounded">
            <h1 className="text-2xl font-bold">Contact Page</h1>
            <p>Feel free to reach out via the contact page.</p>
        </div>
    );
}

export default Contact;
